var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"clipRule":"evenodd","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","d":"M1.333 12C1.333 6.105 6.108 1.33 12 1.33c5.89 0 10.666 4.775 10.666 10.67 0 5.894-4.777 10.67-10.667 10.67S1.332 17.894 1.332 12z","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"1.52","strokeMiterlimit":"10","d":"M16.068 7.895l-5.88 8.206-2.32-2.317","key":1})]);
}

CheckCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
